import { client } from "../client/client";

export const fetchSharesData = async (page, limit, query, status) => {
  try {
    const response = await client.get(
      `/api/v1/product-reporting?page=${page}&limit=${limit}&q=${query}&status=${status}&productId=94e9dd35-b90f-b3d8-dcc1-2f7ae4fc3d6b`,
    );
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportAllShares = async (type, limit, status) => {
  const response = await client.get(
    `/api/v1/product-reporting/export?productId=94e9dd35-b90f-b3d8-dcc1-2f7ae4fc3d6b&format=${type}&limit=${limit}&status=${status}`,
    {
      headers: {
        "Content-Type": type === "pdf" ? "application/pdf" : "text/csv",
      },
      responseType: "arraybuffer",
    },
  );
  return response.data;
};

export const exportMemberTransPdf = async (memberId) => {
  const response = await client.get(
    `/api/v1/product-reporting/export?productId=94e9dd35-b90f-b3d8-dcc1-2f7ae4fc3d6b&memberId=${memberId}&format=pdf`,
    {
      headers: {
        "Content-Type": "application/pdf",
        Accept: "*/*",
      },
      responseType: "arraybuffer",
    },
  );

  return response.data;
};

export const exportMemberTransCsv = async (memberId) => {
  const response = await client.get(
    `/api/v1/product-reporting/export?productId=94e9dd35-b90f-b3d8-dcc1-2f7ae4fc3d6b&memberId=${memberId}&format=csv`,
    {
      headers: {
        "Content-Type": "text/csv",
        Accept: "*/*",
      },
      responseType: "arraybuffer",
    },
  );

  return response.data;
};

export const exportAllTransactions = async (type, limit) => {
  const response = await client.get(
    `api/v1/shares/members-with-shares/export?format=${type}&limit=${limit}`,
    {
      headers: {
        "Content-Type": type === "pdf" ? "application/pdf" : "text/csv",
      },
      responseType: "arraybuffer",
    },
  );
  return response.data;
};

export const exportSelectedShares = async (type, transactions) => {
  const response = await client.post(
    `/api/v1/shares/members-with-shares/export/selected?format=${type}`,
    transactions,
    { responseType: "arraybuffer" },
  );

  return response.data;
};

export const getSharesSummary = async (id) => {
  const response = await client.get(
    `/api/v1/product-reporting/member/${id}/summary?productId=94e9dd35-b90f-b3d8-dcc1-2f7ae4fc3d6b`,
  );
  return response?.data;
};

export const getPersonalShareTranscations = async (page, limit, memberId) => {
  const response = await client.get(
    `/api/v1/product-reporting/transactions?page=${page}&limit=${limit}&memberId=${memberId}&productId=94e9dd35-b90f-b3d8-dcc1-2f7ae4fc3d6b`,
  );
  return response;
};
